<svg width="20" height="20" fill="none" version="1.1" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
 <path d="m3.75 13.125 6.25-6.25 6.25 6.25" stroke="#16151C" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25"/>
</svg>
